// extracted by mini-css-extract-plugin
export default {"root":"J_cBfQ","langForm":"iXnl_h","langLink":"nn27WV","newLang":"I57Hyw","delimiter":"OO8jr3"};